module.exports = __webpack_public_path__ + "cd455783/img/upload-icon.9179ae4e.svg";